/* Search: anchor to the visible viewport and scroll results only */
(function () {
  const viewport = window.visualViewport;
  const mobile = window.matchMedia(
    '(max-width: 749px) and (orientation: portrait)'
  );

  let frame = 0;
  let opening = 0;

  function getDialog() {
    return document.querySelector(
      '#search-modal dialog.search-modal__content'
    );
  }

  function updateViewport() {
    frame = 0;

    const dialog = getDialog();
    if (!dialog?.open || !mobile.matches) return;

    const top = viewport ? viewport.offsetTop : 0;
    const height = viewport ? viewport.height : window.innerHeight;

    dialog.style.setProperty('--sm-search-top', `${top}px`);
    dialog.style.setProperty('--sm-search-visible-height', `${height}px`);
  }

  function scheduleUpdate() {
    if (frame) return;
    frame = requestAnimationFrame(updateViewport);
  }

  function resetScroll(dialog) {
    [
      dialog,
      ...dialog.querySelectorAll(
        '.predictive-search,' +
        '.predictive-search-form,' +
        '.predictive-search-form__content-wrapper,' +
        '.predictive-search-form__content,' +
        '.predictive-search-results__inner'
      )
    ].forEach(function (element) {
      element.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant'
      });
    });
  }

  document.addEventListener('dialog:open', function (event) {
    const dialog = getDialog();

    if (
      !dialog?.open ||
      !(event.target instanceof Element) ||
      !(event.target === dialog || event.target.contains(dialog))
    ) return;

    const thisOpening = ++opening;

    dialog.querySelectorAll('[data-sm-search-keyboard-spacer]')
      .forEach(function (element) {
        element.remove();
      });

    updateViewport();
    resetScroll(dialog);

    const input = dialog.querySelector('#cmdk-input');
    input?.focus({ preventScroll: true });

    requestAnimationFrame(function () {
      if (!dialog.open || thisOpening !== opening) return;
      updateViewport();
      resetScroll(dialog);
    });
  });

  document.addEventListener('focusin', scheduleUpdate);
  document.addEventListener('focusout', scheduleUpdate);

  window.addEventListener('resize', scheduleUpdate, {
    passive: true
  });

  window.addEventListener('orientationchange', scheduleUpdate, {
    passive: true
  });

  if (viewport) {
    viewport.addEventListener('resize', scheduleUpdate, {
      passive: true
    });

    viewport.addEventListener('scroll', scheduleUpdate, {
      passive: true
    });
  }
})();
